import { sfIcons, sfCmdIcon } from '@/assets/json/qxicon'
export default {
	methods: {
		// 获取头部站点下拉选
		getOrgids(isFen = false) {
			let userInfo = this.getItem('wlwUserInfo') || {}
			let userInfos = JSON.parse(userInfo)
			let params = {
				orgId: '',
			}
			if (isFen) {
				params.orgId = this.allOrgId
			} else {
				params.orgId = userInfos.orgId
			}
			this.$http
				.getAction(this.$api.sffindDeviceByOrgId, params)
				.then((res) => {
					console.log(res)
					if (res.meta.success) {
						let datas = res.data || []
						this.orgSelect = datas || []
						if (datas && datas.length) {
							this.$set(this.selectForm, 'deviceId', datas[0]['id'])
							// 获取页面上相关的其它数据
							setTimeout(() => {
								// 获取详情数据
								this.getInfos()
								this.getEquipCmd()
							}, 300)
						} else {
							this.loading = false
						}
					} else {
						this.$set(this.selectForm, 'deviceId', '')
						this.orgSelect = []
						this.loading = false
					}
				})
				.catch(() => {
					this.$set(this.selectForm, 'deviceId', '')
					this.orgSelect = []
					this.loading = false
				})
		},
		getAllOrgids() {
			let userInfo = this.getItem('wlwUserInfo') || {}
			let userOrg = this.getItem('wlwOrg') || {}
			let userOrgs = JSON.parse(userOrg)
			let userInfos = JSON.parse(userInfo)
			let params = {
				parentOrgId: userInfos.orgId,
				type: '2',
			}
			this.$http
				.getAction(this.$api.findChildOrgByParentOrgId, params)
				.then((res) => {
					console.log(res)
					if (res.meta.success) {
						let datas = res.data || []
						this.orgAllSelect = datas || []
						if (datas && datas.length) {
							this.allOrgId = datas[0]['orgId']
							this.getOrgids(true)
						} else {
							this.loading = false
						}
					} else {
						this.orgSelect = []
						this.orgAllSelect = []
						this.loading = false
					}
				})
				.catch(() => {
					this.orgSelect = []
					this.orgAllSelect = []
					this.loading = false
				})
		},
		// 分公司网点下拉选选择
		changeAllOrg(val) {
			this.allOrgId = val
			this.getOrgids(true)
		},
		// 获取详情列表数据
		getInfos() {
			let params = this.selectForm
			this.$http
				.getAction(this.$api.sflatestDeviceStateData, params)
				.then((res) => {
					console.log(res)
					if (res.meta.success) {
						let datas = res.data || {}
						this.infoData = datas || {}
						if (datas.d && datas.d.length) {
							// this.isWarn = false

							this.infoList = datas.d.reverse()
						} else {
							this.infoList = []
						}
					} else {
						this.infoData = {}
						this.infoList = []
					}
				})
				.catch(() => {
					this.infoData = {}
					this.infoList = []
				})
				.finally((err) => {
					setTimeout(() => {
						this.loading = false
					}, 500)
				})
		},
		// 获取设备可执行指令
		getEquipCmd() {
			let params = this.selectForm
			this.$http
				.getAction(this.$api.sflatestDeviceActionData, params)
				.then((res) => {
					console.log(res)
					if (res.meta.success) {
						let datas = res.data || {}
						if (datas.d && datas.d.length) {
							// this.isWarn = false

							this.cmdList = datas.d || []
						} else {
							this.cmdList = []
						}
					} else {
						this.cmdList = []
					}
				})
				.catch(() => {
					this.cmdList = []
				})
		},
		// 指令一键启动
		setHandle({ pid, success }, index) {
			let params = Object.assign({}, this.selectForm)
			this.$set(params, 'pid', pid)
			this.$set(params, 'start', !success)

			this.$confirm(`确定操作此设备?`, '操作', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			})
				.then(() => {
					// 请求接口
					this.$http
						.getAction(this.$api.sfactionOneCommand, params)
						.then((res) => {
							if (res.meta.success) {
								this.$message('操作成功', 'success')
								let datas = res.data['d'] || []
								if (datas && datas.length) {
									let changeData = datas[0] || {}
									this.$set(this.cmdList, index, {
										...this.cmdList[index],
										success: changeData.success,
									})
								}
							} else {
								this.$message('操作失败', 'error')
							}
						})
						.catch(() => {
							this.$message('服务出错，请稍后重试', 'error')
						})
				})
				.catch(() => {})
		},
		// 点击刷新
		refresh() {
			// 重新请求指令状态数据
			this.getInfos()
		},
		// 指令状态图标
		setInfoIcons({ pidDesc }) {
			let iconIndex = sfIcons.findIndex((item) => {
				return item.key == pidDesc || pidDesc.indexOf(item.key) > -1
			})
			if (iconIndex > 0) {
				return sfIcons[iconIndex]['path']
			} else {
				return sfIcons[0]['path']
			}
		},
		setCmdIcons({ success, pidDesc }) {
			if (pidDesc.indexOf('罐区时控') > -1 && pidDesc.indexOf('开关') > -1) {
				if (success) {
					return require('@/assets/image/sf/icon_kgh.png')
				} else {
					return require('@/assets/image/sf/icon_kgn.png')
				}
			} else {
				let iconIndex = sfCmdIcon.findIndex((item) => {
					return item.key == pidDesc || pidDesc.indexOf(item.key) > -1
				})

				if (iconIndex > 0) {
					if (success) {
						return sfCmdIcon[iconIndex]['actPath']
					} else {
						return sfCmdIcon[iconIndex]['path']
					}
				} else {
					return sfCmdIcon[0]['path']
				}
			}
		},
	},
}
